import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect, useState } from 'react';
import gundi_logo from 'images/gundi_logo.png';
import { acceptEula } from 'api/users/usersApi';
import { AttentionIcon } from './ProjectIcons';
import { useTranslation } from 'react-i18next';

export function EulaModal() {
  const { keycloak } = useKeycloak();
  const [eulaChecked, setEulaChecked] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const { t } = useTranslation();
  const handleAccept = (e: any) => {
    setEulaChecked(e.target.checked);
    if (e.target.checked) setErrorMsg(false);
  };

  const handleContinue = async () => {
    if (eulaChecked) {
      if (keycloak.token) await acceptEula(keycloak.token);
      window.location.reload();
    } else setErrorMsg(true);
  };

  return (
    <div
      className={`fixed inset-0 z-[60] overflow-y-auto bg-unlisted-medium-gray bg-opacity-80`}
    >
      <div className="flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center opacity-100 sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-greyscale-5 opacity-75"></div>
        </div>
        <div className="z-30 my-24 inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom opacity-100 shadow-xl transition-all">
          <div className="bg-white px-6 pt-5 text-left">
            <div className="flex flex-row items-baseline justify-center">
              <img src={gundi_logo} alt="gundi logo" className="h-6" />
              <label className="ml-2 font-bold">GUNDI</label>
            </div>
            <h3 className="text-lg font-medium leading-6 text-ui-text-primary-text">
              {t("You must accept Gundi's policies to continue")}
            </h3>
            <div className="mt-2">
              <p className="text-md w-96 text-ui-text-primary-text">
                {t('By clicking accept policies, I agree to the')}{' '}
                <a
                  href="https://projectgundi.org/User-Agreement"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-accent-green"
                >
                  {t('End User License Agreement')}
                </a>{' '}
                {`${t('and')} ${t('The (masculine)(plural)').toLowerCase()}`}{' '}
                <a
                  href="https://projectgundi.org/Legal-Pages/Terms-of-Use"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-accent-green"
                >
                  {t('Site Terms & Conditions')}
                </a>
                , {t('and consent to the privacy policies referenced therein.')}
              </p>
            </div>
            <div className="my-4">
              <input
                className="cursor-pointer accent-ui-cta-primary"
                checked={eulaChecked}
                type="checkbox"
                value="30"
                id="log_level"
                onChange={(e: any) => handleAccept(e)}
              />
              <label className="text-md mx-2 inline-block text-ui-text-primary-text">
                {t('Accept Policies')}
              </label>
            </div>
            {errorMsg && (
              <div className="mb-3 flex flex-row items-end rounded-sm bg-unlisted-very-light-orange p-3 text-sm">
                <AttentionIcon />
                <p className="-mb-0.5 ml-2 text-ui-text-primary-text">
                  {t('You must check Accept Policies to continue')}
                </p>
              </div>
            )}
          </div>
          <div className="flex justify-center bg-greyscale-11 px-4 pb-6 sm:px-6">
            <button
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-transparent bg-brand-accent-green px-6 py-3 text-base font-bold text-white shadow-sm hover:bg-ui-cta-primary focus:outline-none focus:ring-2 focus:ring-ui-status-running focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={handleContinue}
            >
              {t('Continue')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
